import { Box, IconButton } from '@mui/material'
import { icons } from '../../constants/images'

import UploadFileIcon from '@mui/icons-material/UploadFile';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import FilterListIcon from '@mui/icons-material/FilterList';
import DeleteIcon from '@mui/icons-material/Delete';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import ButtonCustom from '../button/buttonCustom';
import { useSelector } from 'react-redux';
type Props = {
    handleClickOpenPermis: any
    inputFolder: any
    handleClickOpenCreate: any
    setOpenUploadFile: any
    setOpenFilter: any
    levelfiles: any
    bulkFileDelete: any
    bulkFileDownload: any
    setOpenDialogIndex: any
    type: string
}
export default function MenuButtom(props: Props) {
    const {
        handleClickOpenPermis,
        inputFolder,
        handleClickOpenCreate,
        setOpenUploadFile,
        setOpenFilter,
        levelfiles,
        bulkFileDelete,
        bulkFileDownload,
        setOpenDialogIndex,
        type,
    } = props
    const { profile, loading } = useSelector((state: any) => state.profile)
    const permit = profile?.permission || []

    return (
        <>
            <Box sx={{ display: { lg: 'none', xs: 'flex' }, justifyContent: "flex-end" }}>



                {inputFolder.idReferFolder && (type !== 'my' ? inputFolder?.permissionLevel > 0 ? inputFolder?.permissionLevel === 2 : inputFolder?.permitLevel : true) &&
                    <IconButton onClick={() => { handleClickOpenPermis() }} aria-label="Example" >
                        <icons.security1 />
                    </IconButton>}
                {(type !== 'my' ? inputFolder?.permissionLevel > 0 ? inputFolder?.permissionLevel === 2 : inputFolder?.permitLevel : true) && levelfiles?.filter((x: any) => x?.check === true)?.length > 0 &&
                    <>
                        <IconButton onClick={() => { bulkFileDownload() }} aria-label="Example" >
                            <icons.downloadButton style={{ color: '#026735' }} />
                        </IconButton>
                        <IconButton onClick={() => { bulkFileDelete() }} aria-label="Example" >
                            <DeleteIcon sx={{ color: '#ff0000' }} />
                        </IconButton>
                    </>}
                {(type !== 'my' ? (inputFolder?.stepView === 1 || inputFolder?.permissionLevel > 0 ? inputFolder?.permissionLevel === 2 : inputFolder?.permitLevel) : true) && inputFolder?.stepView < 5 &&
                    <IconButton onClick={() => { handleClickOpenCreate() }} aria-label="Example" >
                        <CreateNewFolderIcon sx={{ color: '#026735' }} />
                    </IconButton>}
                {(type !== 'my' ? inputFolder?.permissionLevel > 0 ? inputFolder?.permissionLevel === 2 : inputFolder?.permitLevel : true) && inputFolder?.stepView > 1 &&
                    <IconButton onClick={() => { setOpenDialogIndex(true) }} aria-label="Example" >
                        <DriveFolderUploadIcon sx={{ color: '#ff7717' }} />
                    </IconButton>
                }
                {(type !== 'my' ? (inputFolder?.permitUpload && inputFolder?.stepView > 1) : inputFolder?.stepView > 1) &&
                    <IconButton onClick={() => { setOpenUploadFile(true) }} aria-label="Example" >
                        <UploadFileIcon />
                    </IconButton>
                }
                <IconButton onClick={() => setOpenFilter(true)} aria-label="Example" >
                    <FilterListIcon />
                </IconButton>
            </Box>
            <Box sx={{ display: { lg: "flex", xs: 'none' } }}>
                {inputFolder.idReferFolder && (type !== 'my' ? inputFolder?.permissionLevel > 0 ? inputFolder?.permissionLevel === 2 : inputFolder?.permitLevel : true) && <ButtonCustom variant={'outlined'}
                    startIcon={<icons.security1 />}
                    textButton={'การเข้าถึง'}
                    onClick={() => { handleClickOpenPermis() }}
                    style={{ marginRight: '8px' }}
                    btnStyle={{
                        '&.MuiButton-outlined': {
                            color: `#0A77FF !important`,
                            border: `2px solid #0A77FF !important`,
                            borderRadius: "10px !important",
                            '&:hover': {
                                color: `#0A77FF  !important`,
                                border: `2px solid #0A77FF !important`,
                                backgroundColor: '#EFFFF7 !important'
                            },
                        },
                    }} />}
                {(type !== 'my' ? inputFolder?.permissionLevel > 0 ? inputFolder?.permissionLevel === 2 : inputFolder?.permitLevel : true) && levelfiles?.filter((x: any) => x?.check === true)?.length > 0 &&
                    <>
                        <ButtonCustom variant={'outlined'}
                            endIcon={<icons.downloadButton />}
                            textButton={'ดาวน์โหลด'}
                            onClick={() => { bulkFileDownload() }}
                            style={{ marginRight: '8px' }}

                            btnStyle={{
                                '&.MuiButton-outlined': {
                                    color: `#323539 !important`,
                                    border: `2px solid #E5E5E7 !important`,
                                    borderRadius: "10px !important",
                                    '&:hover': {
                                        color: `#323539  !important`,
                                        border: `2px solid #E5E5E7 !important`,
                                        backgroundColor: '#EFFFF7 !important'
                                    },
                                },
                            }} />
                        <ButtonCustom variant={'outlined'}
                            textButton={'ลบไฟล์'}
                            onClick={() => { bulkFileDelete() }}
                            style={{ marginRight: '8px' }}

                            btnStyle={{
                                '&.MuiButton-outlined': {
                                    color: `red !important`,
                                    border: `2px solid red !important`,
                                    borderRadius: "10px !important",
                                    '&:hover': {
                                        color: `red  !important`,
                                        border: `2px solid red !important`,
                                        backgroundColor: '#fff !important'
                                    },
                                },
                            }} />
                    </>}
                {(type !== 'my' ? (inputFolder?.stepView === 1 ? permit?.find((x: any) => x?.code === 'Level1.Add')?.permit : (inputFolder?.permissionLevel > 0 ? inputFolder?.permissionLevel === 2 : inputFolder?.permitLevel)) : true) && inputFolder?.stepView < 5 && <><ButtonCustom variant={'outlined'}
                    startIcon={<icons.circleButton />}
                    textButton={`สร้าง${inputFolder?.stepView === 1 ? 'ตู้' : inputFolder?.stepView === 2 ? 'ชั้น' : inputFolder?.stepView === 3 ? 'แฟ้ม' : inputFolder?.stepView === 4 ? 'ประเภท' : ''}เอกสาร`}
                    onClick={() => { handleClickOpenCreate() }}
                    style={{ marginRight: '8px' }} />

                </>}
                {(type !== 'my' ? inputFolder?.permissionLevel > 0 ? inputFolder?.permissionLevel === 2 : inputFolder?.permitLevel : true) && inputFolder?.stepView > 1 && inputFolder?.stepView < 5 && <ButtonCustom variant={'outlined'}
                    startIcon={<DriveFolderUploadIcon />}
                    textButton={`นำเข้าดัชนี`}
                    onClick={() => { setOpenDialogIndex(true) }}
                    style={{ marginRight: '8px' }}
                    btnStyle={{
                        '&.MuiButton-outlined': {
                            color: `#ff7717 !important`,
                            border: `2px solid #ff7717 !important`,
                            borderRadius: "10px !important",
                            '&:hover': {
                                color: `#ff7717  !important`,
                                border: `2px solid #ff7717 !important`,
                                backgroundColor: '#EFFFF7 !important'
                            },
                        },
                    }} />}
                {(type !== 'my' ? (inputFolder?.permitUpload && inputFolder?.stepView > 1) : inputFolder?.stepView > 1) && <ButtonCustom variant={'outlined'}
                    startIcon={<UploadFileIcon />}
                    textButton={'อัปโหลด'}
                    onClick={() => { setOpenUploadFile(true) }} />}

            </Box>
        </>
    )
}
